module.exports = __webpack_public_path__ + "static/media/arch-22.e351c634.jpg";